import { render, staticRenderFns } from "./CategoryMenuListItem.vue?vue&type=template&id=20fb7ff6&scoped=true&"
import script from "./CategoryMenuListItem.vue?vue&type=script&lang=ts&"
export * from "./CategoryMenuListItem.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryMenuListItem.vue?vue&type=style&index=0&id=20fb7ff6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fb7ff6",
  null
  
)

export default component.exports